import { EntityModel } from 'src/core/services/data/models';
import { DataService, property } from 'src/core/services/data.service';
import { BookemZulu as Model } from 'src/core/services/data/JayDataContext';

export class ProductServiceTypeDataService extends DataService<typeof Model.Products.Logic.ViewModels.ProductServiceTypeSummary, Model.Products.Logic.ViewModels.ProductServiceTypeSummary, ProductServiceTypeSummary> {
    protected map(entity: Model.Products.Logic.ViewModels.ProductServiceTypeSummary): ProductServiceTypeSummary {
        return new ProductServiceTypeSummaryModel(entity);
    }

    public static make(ctx?: any): ProductServiceTypeDataService {
        return new ProductServiceTypeDataService(ctx, ctx => ctx.ProductServiceTypeSummaries);
    }

    public add() {
        const entity = new Model.Products.Logic.ViewModels.ProductServiceTypeSummary();
        return entity;
    }
}

export class ProductServiceTypeSummaryModel extends EntityModel<Model.Products.Logic.ViewModels.ProductServiceTypeSummary, ProductServiceTypeSummary> implements ProductServiceTypeSummary {
    @property<ProductServiceTypeSummaryModel>(o => o.entity.id, (o, value) => o.entity.id = value)
    public id: number;

    @property<ProductServiceTypeSummaryModel>(o => o.entity.categoryId, (o, value) => o.entity.categoryId = value)
    public categoryId: number;

    @property<any>(o => o.entity.displayName, (o, value) => o.entity.displayName = value)
    public displayName: string;

    @property<ProductServiceTypeSummaryModel>(o => o.entity.categoryDisplayName, (o, value) => o.entity.categoryDisplayName = value)
    public categoryDisplayName: string;
}



// WEBPACK FOOTER //
// ./src/app/products/product-service-types/parts/product-service-type-editor.data.ts